import { render, staticRenderFns } from "./CEO.vue?vue&type=template&id=621f38aa"
import script from "./CEO.vue?vue&type=script&lang=js"
export * from "./CEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports